import React, {FunctionComponent, useEffect, useState} from "react";
import { pillName } from './../../../utils/utils';
interface Props {
    id: string,
    // classList: string,
    onClick: (e: any) => void,

    value: string,

    numberOfResults: number,

    isSelected?: boolean,

    isMobile?: boolean,

    isHidden?: boolean,
}

const Pill: FunctionComponent<Props> = (props) => {
    let classList = "pill-item";

    if (props.isSelected) {
        classList += " selected";
    }

    if(props.isHidden) {
        classList += " hidden";
    }

    return (
        <div className={classList} id={props.value}
             key={props.value}
             onClick={(e) => props.onClick(e)}
        >
            <span className="pill-item-label">
                {props.value === pillName.PRODUCT ? props.value + "s" : props.value}
            </span>
            {!props.isMobile && <span className="pill-item-number">
                ({props.numberOfResults})
            </span>}
        </div>
    )
}

export default Pill;